import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Help } from '@mui/icons-material';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} componentsProps={{ tooltip: { className: className } }} />
))(`
    color: black;
    background-color: white;
    border: 1px dotted lightgrey;
    font-size: 1em;
    minWidth: 600px;
`);

export const HelpTooltip = ({ children, ...rest }) =>
  <StyledTooltip title={children} placement="right-start" {...rest}>
    <Help color="primary" fontSize="small" />
  </StyledTooltip>
